module.exports = __webpack_public_path__ + "static/media/sse-airtricity.fc4026cb.png";